// src/utils/apiAuth.js — attach the signed-in admin's Supabase token to every
// same-origin /api/ call (25 Oct 2026).
//
// The admin API routes now require `Authorization: Bearer <jwt>` (see
// api/_lib/requireAdminCjs.js). About 20 screens call those routes with plain
// fetch() and no token; rather than edit each caller, this wraps fetch once.
// It only touches same-origin /api/ requests that don't already carry an
// Authorization header, so calls to Supabase, Daily, LiveKit, etc. are untouched.
import { supabase } from '../supabaseClient';

function isAdminApi(url) {
  try {
    const u = new URL(url, window.location.origin);
    return u.origin === window.location.origin && u.pathname.startsWith('/api/');
  } catch (_e) {
    return false;
  }
}

export function installApiAuth() {
  if (typeof window === 'undefined' || !window.fetch || window.__sanoireApiAuth) return;
  window.__sanoireApiAuth = true;
  const original = window.fetch.bind(window);

  window.fetch = async function sanoireFetch(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isAdminApi(url)) return original(input, init);

    const opts = init ? { ...init } : {};
    const headers = new Headers(opts.headers || (input && typeof input !== 'string' ? input.headers : undefined) || {});
    if (!headers.has('Authorization')) {
      let token = '';
      try {
        const { data } = await supabase.auth.getSession();
        token = (data && data.session && data.session.access_token) || '';
      } catch (_e) { token = ''; }
      if (token) headers.set('Authorization', 'Bearer ' + token);
    }
    opts.headers = headers;
    return original(input, opts);
  };
}
